import React, { Component } from 'react';

import { HomePageBanner } from './HomePageBanner';
import { HomePageContent } from './HomePageContent';

import { AppContext } from '../../contexts/AppContext';

// import { HamburgerMenuIcon } from '../../icons/HamburgerMenuIcon';

import '../../../css/components/home-page.scss';

export class HomePage extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    window.scrollTo(0, 0);

    this.state = {
      expandedSideBar: false,
    }
  }

  toggleExpandSideBar = () => {
    this.setState({
      expandedSideBar: !this.state.expandedSideBar,
    })
  }

  render(){
    return (
      <div className="HomePage">
        <HomePageBanner />
        <HomePageContent />
      </div>
    );
  }
}